import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faQuestion, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import "./trendingAltTokens.css"

export default function EnrichedTokensList() {
  const [tokens, setTokens] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const isLocal = window.location.hostname === 'localhost';
  const baseUrl = isLocal
    ? 'http://localhost:5000'
    : 'https://www.trendscout.club';

  const openModal = (reasoning) => {
    setModalContent(reasoning);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalContent('');
  };


  const fetchTokens = async () => {
    try {
      const res = await fetch(`${baseUrl}/api/trendingAltTokens`);
      if (!res.ok) throw new Error(res.statusText);
      setTokens(await res.json());
    } catch (err) {
      console.error('Failed to load enriched tokens', err);
    }
  };

  useEffect(() => {
    fetchTokens();
    const timer = setInterval(fetchTokens, 10 * 60 * 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="alts-container">
      <h2>AI Tracking</h2>
      <div className="alts-grid">
        {tokens.slice(0, 30).map(t => {
          const sym = t.symbol.toUpperCase();
          const base = sym.endsWith("USDT") ? sym.slice(0, -4) : sym;
          const pair = `${base}_USDT`;
          const url = `https://www.binance.com/en/trade/${pair}`;
          const changeClass = t.priceChange >= 0 ? "positive" : "negative";

            let directionIcon;
              if (t.direction === 'LONG') {
                directionIcon = <FontAwesomeIcon icon={faArrowUp} style={{ color: '#19ff6b' }} />;
              } else if (t.direction === 'SHORT') {
                directionIcon = <FontAwesomeIcon icon={faArrowDown} style={{ color: 'red' }} />;
              } else {
                directionIcon = <FontAwesomeIcon icon={faQuestion} style={{ color: 'gray' }} />;
              }


          return (
            <a
              key={t.symbol}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="token-card"
            >
              <div className="token-symbol">{base}&nbsp;{directionIcon}</div>
              <div className="token-price">
                {t.price !== undefined ? `$${t.price.toString()}` : '—'}
              </div>
              <div className={`token-change ${changeClass}`}>
                {typeof t.priceChange === 'number' ? `${t.priceChange.toFixed(2)}%` : '—'}
              </div>
              <div className="token-points">{typeof t.points === 'number' ? `${t.points} Confirmations` : '—'}</div>
              {typeof t.reasoning === 'string' && t.reasoning.trim() !== '' && (
                <div className="token-info-icon-wrapper">
                  <FontAwesomeIcon
                    icon={faInfoCircle}
                    className="token-info-icon"
                    onClick={(e) => {
                      e.preventDefault(); 
                      e.stopPropagation();     
                      openModal(t.reasoning); 
                    }}
                  />
                </div>
              )}
              <div className="token-reasoning-status">
                {typeof t.reasoning !== 'string' || t.reasoning.trim() === '' ? (
                  <span className="missing-reasoning">⚠ No reasoning</span>
                ) : null}
              </div>
            </a>
          );
        })}
      </div>
      {showModal && (
          <div className="info-modal" onClick={closeModal}>
            <div className="info-modal-content" onClick={e => e.stopPropagation()}>
              <div className='infomodalmain'>  
                <h3>AI Reasoning</h3>
                <p>{modalContent}</p>
                 </div>
                <button onClick={closeModal}>Close</button>
             </div>
          </div>
         )}
    </div>
  );
}